import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { Rest } from 'app/rest/rest_client';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { saveAs } from 'file-saver';
@Injectable()
export class ExcelService {
	constructor(private datePipe: DatePipe) {}
	//dateNF = 'dd/mm/yyyy hh:mm'; //ejemplo fecha con hora
	//dateNF = 'dd/mm/yyyy;@' ejemplo fecha sin hora
	public exportAsExcelFile({
		json,
		fileName,
		header,
		columnsMetadata,
	}: {
		json: any[];
		fileName: string;
		header?: string[];
		columnsMetadata?: any[];
	}): void {
		const defaultDateNF = 'dd/mm/yyyy hh:mm';
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
			header,
			cellDates: true,
			dateNF: defaultDateNF, 
 
		});
    this.setColumnsWith(columnsMetadata, worksheet);
		console.log(JSON.stringify(json));
	  // Aplicar estilos condicionales
	  this.applyConditionalFormatting(worksheet, columnsMetadata, json);
		const workbook: XLSX.WorkBook = {
			Sheets: { data: worksheet },
			SheetNames: ['data'],
		};
		const excelBuffer: any = XLSX.write(workbook, {
			bookType: 'xlsx',
			type: 'array',
			cellDates: true,
 		});
		this.saveAsExcelFile(excelBuffer, fileName);
	}
	private applyConditionalFormatting(
		worksheet: XLSX.WorkSheet,
		columnsMetadata: any[],
		data: any[]
	  ): void {
		// Encuentra la columna correspondiente (ejemplo para booleanos)
		const booleanColumnIndex = columnsMetadata?.findIndex(
		  (col) => col.type === 'boolean'
		);
	  
		if (booleanColumnIndex === -1) {
		  return; // No hay columnas booleanas
		}
	  
		// Recorre cada fila y aplica estilos
		data.forEach((row, rowIndex) => {
		  const cellAddress = XLSX.utils.encode_cell({
			r: rowIndex + 1, // +1 porque la fila 0 son encabezados
			c: booleanColumnIndex,
		  });
	  
		  const cell = worksheet[cellAddress];
		  if (cell) {
			const isTrue = row[columnsMetadata[booleanColumnIndex].field] === true;
			cell.s = {
			  fill: {
				patternType: 'solid',
				fgColor: { rgb: isTrue ? '00FF00' : 'FF0000' }, // Verde o rojo
			  },
			  font: {
				bold: true,
				color: { rgb: 'FFFFFF' }, // Texto blanco
			  },
			};
		  }
		});
	  }
	private saveAsExcelFile(buffer: any, fileName: string): void {
		const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
		FileSaver.saveAs(
			data,
			fileName + '_export_' + this.datePipe.transform(new Date(), 'yyyyMMddHHmmss') + EXCEL_EXTENSION
		);
	}

	setColumnsWith(columns: any[], workSheet: XLSX.WorkSheet) {
		var COL_INDEX = 0;
    if(!columns) return 
		for (const column of columns) {
			if (column.excelWidth && column.excel) {
				if (!workSheet['!cols']) workSheet['!cols'] = [];
				/* create column metadata object if it does not exist */
				if (!workSheet['!cols'][COL_INDEX]) workSheet['!cols'][COL_INDEX] = { wch: column.excelWidth};
				/* set column width */
				workSheet['!cols'][COL_INDEX].wpx = column.excelWith;
			}
      if(column.excel){COL_INDEX++;}
		}
	}

	//HTML TABLE TO EXCEL
	public exportTableAsExcelFile(element: HTMLElement, excelFileName: string): void {
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, {
			dateNF: 'dd/mm/yyyy;@',
			cellDates: true,
			raw: true,
		});
		const workbook: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, excelFileName);
	}

	//HTML TABLE TO EXCEL
	public exportTableAsExcelFileV2(
		element: HTMLElement,
		excelFileName: string,
		tableData: any,
		columns: String[],
		tableDataExcel?: any[]
	): void {
		//const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { dateNF: 'dd/mm/yyyy;@', cellDates: true, raw: true });
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(tableDataExcel, {});

		for (let i = 0; i < tableData.length; i++) {
			for (const key in tableData[i]) {
				if (tableData[i].hasOwnProperty(key)) {
					const element = tableData[i][key];
					const cell = ws[XLSX.utils.encode_cell({ r: i + 1, c: columns.indexOf(element.field) })];
					const status = element.status;
					if (status) {
						if (cell) {
							if (!cell.s) {
								cell.s = {}; // Initialize 's' property if it doesn't exist
							}
							cell.s = { fill: { fgColor: { rgb: this.getStatusColor(status) } } }; // Set cell color
						} else {
							// Handle the case where 'cell' is undefined
							// For example, initialize 'cell' or log an error
						}
					}
				}
			}
		}

		const workbook: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, excelFileName);
	}

	//HTML TABLE TO EXCEL WITH ROWS
	public exportTableAsExcelFileNumRows(element: HTMLElement, excelFileName: string, numRows: number): void {
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, {
			dateNF: 'dd/mm/yyyy;@',
			cellDates: true,
			raw: true,
			sheetRows: numRows,
		});
		const workbook: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, excelFileName);
	}

	exportToExcel(data: Rest.ReportResponseItem[]): void {
		const headers: string[] = this.extractHeaders(data);
		const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([headers]);

		// Populate data
		data.forEach((row, rowIndex) => {
			headers.forEach((header, colIndex) => {
				const cellData = row[header];
				const value = cellData?.value || '';
				const status = cellData?.status || '';
				const cell = ws[XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex })];
				if (cell) {
					cell.v = value; // Set cell value
					if (status) {
						cell.s = { fill: { fgColor: { rgb: this.getStatusColor(status) } } }; // Set cell color
					}
				}
			});
		});

		const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
		const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, 'exported_data');
	}

	extractHeaders(data: any[]): string[] {
		const headersSet: Set<string> = new Set();
		data.forEach((row) => {
			Object.keys(row).forEach((key) => {
				headersSet.add(key);
			});
		});
		return Array.from(headersSet);
	}

	getStatusColor(status: string): string {
		// Define color mappings based on status
		const colorMap: { [key: string]: string } = {
			yellow: 'FFFF00',
			// Add more color mappings as needed
		};
		return colorMap[status] || 'FFFFFF'; // Default to white if status not found
	}

	private isColor(str: string): boolean {
		// Check if the string represents a color (you can customize this check based on your requirements)
		return /^#[0-9A-F]{6}$/i.test(str);
	}

	private hexToRgb(hex: string): string {
		// Convert hex color to RGB format
		const bigint = parseInt(hex.slice(1), 16);
		const r = (bigint >> 16) & 255;
		const g = (bigint >> 8) & 255;
		const b = bigint & 255;
		return `${r},${g},${b}`;
	}



	//******** LO PONGO AQUÍ POR SI NO VIENE DESDE EL ENTITY ******/
  	//versió excel taula dinàmica
	  exportExcelWithColumnsMetadata(fileName, columns, files) {
		fileName = fileName.replace(/\s/g, '');
		fileName.trim();
		//excelColumns = excelColumns.map(item => ({ ...item, header: this.translate.instant(item.header) }));
			const excelEntities = files.map((entity) =>
				this.mapEntityMetadata(entity, columns)
			);
			let fullFileName = fileName;
			this.exportAsExcelFile({ json: excelEntities, fileName: fullFileName, columnsMetadata: columns });
	}

    mapEntityMetadata<T, U>(
		entity: T,
		columnsMetadata: [
			{
				field: string;
				header: string;
				excel: Boolean;
				bindField?: (entity: any) => any;
				excelType?: string;
				excelFormat?: string;
			}
		]
	): U {
		const entityMapped: any = {};
		columnsMetadata.forEach((column) => {
			if (column.excel) {
				let value = '';
				if (column.bindField) {
					value = column.bindField(entity);
				} else {
					value = entity[column.field];
				}
				// entityMapped[column.header] = value;
				entityMapped[column.header] = {
					v: value ?? '',
					...(column.excelFormat && value !== null && value !== undefined  ? { z: column.excelFormat } : {}),
					...(column.excelType && value !== null && value !== undefined  ? { t: column.excelType } : {}),
				};
			}
		});
		return entityMapped as U;
	}

}
